/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { Stack } from "@mui/material";
import ButtonBase from "@mui/material/ButtonBase";
import React from "react";

import MaterialSymbol from "../../../../components/MaterialSymbol";
import Modal from "../../../../components/Modal";
import Steppers from "../../../../components/Stepper/Stepper";
import Typography from "../../../../components/Typography";

import { useDrawdownRequestContext } from "./DrawdownRequestContext";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";

interface DrawdownRequestModalProps {
  open: boolean;
  onClose: () => void;
}

const DrawdownRequestModal = ({ open, onClose }: DrawdownRequestModalProps) => {
  const { state, setState, reset } = useDrawdownRequestContext();
  const tabViewBgColor = [0, 1].includes(state.tabIndex) ? "primary25" : undefined;
  const tabViews = [
    { view: <Step1 />, title: "Create order" },
    { view: <Step2 />, title: "Create order" },
    { view: <Step3 />, title: "Create order" },
    { view: <Step4 />, title: "Create order" },
  ];

  const scrollRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    scrollRef?.current?.scrollTo(0, 0);
  }, [state.tabIndex, scrollRef]);

  return (
    <Modal
      sx={{
        overflow: "hidden",
      }}
      scrollRef={scrollRef}
      title={
        state.tabIndex > 0 ? (
          <ButtonBase
            onClick={() => setState({ tabIndex: state.tabIndex - 1 })}
            sx={{ color: colors.grey700 }}
          >
            <Stack display="inline-flex" flexDirection="row" gap="6px">
              <MaterialSymbol>west</MaterialSymbol>
              <Typography variant="body2">Back</Typography>
            </Stack>
          </ButtonBase>
        ) : null
      }
      open={open}
      handleClose={() => {
        onClose();
        reset();
      }}
      header={
        <Steppers
          enableBackBtn={false}
          maxSteps={4}
          activeStep={state.tabIndex}
          title={tabViews[state.tabIndex].title}
          previousStep={1}
          disableStepperClick
          setPageIndex={(value) => {
            setState({ tabIndex: value });
          }}
        />
      }
      contentBg={tabViewBgColor}
      headerDivider
      maxWidth="md"
      paperProps={{
        sx: {
          height: {
            sm: "inherit",
            md: "844px",
          },
          overflow: "hidden",
        },
      }}
    >
      {tabViews[state.tabIndex].view}
    </Modal>
  );
};

export default DrawdownRequestModal;
